import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { CPFMask } from '../ui/CPFMask';
import { DateMask } from '../ui/DateMask';
import { FullNameInput } from '../ui/FullNameInput';
import Spacer from '../ui/Spacer'; 
import "./ValidationCheckForm.css";

import { validateDocumentNumber, validateDate, validateName } from '../../utils/Validations';

export function ValidationCheckForm({ onSubmit }) {
  const { control, handleSubmit, formState: { errors }, setError } = useForm();
  const [loading, setLoading] = useState(false);
  const [isValidated, setIsValidated] = useState(false);

  const onSubmitHandler = async (data) => {
    let hasError = false;

   /* if (!validateName(data.name)) {
      setError("name", { type: "manual", message: "Nome inválido. Informe o nome completo." });
      hasError = true;
    }*/

    if (!validateDocumentNumber(data.documentNumber)) {
      setError("documentNumber", { type: "manual", message: "CPF inválido. Verifique o formato." });
      hasError = true;
    }

    /*if (!validateDate(data.birthday)) {
      setError("birthday", { type: "manual", message: "Data inválida. Use o formato DD/MM/AAAA." });
      hasError = true;
    }*/

    if (hasError) return; 

    setLoading(true);

    try {
      const response = await onSubmit({
        //name: data.name,
        documentNumber: data.documentNumber.replace(/[^\d]/g, '')//, 
        //birthday: data.birthday
      });

      console.log(response);
      if (response.status === 201) {
        setIsValidated(true);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      setIsValidated(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="form-container">
  
      {/* CPF */}
      <Controller
        name="documentNumber"
        control={control}
        defaultValue=""
        render={({ field }) => (
          <CPFMask 
            {...field}
            disabled={isValidated}
            error={errors.documentNumber?.message}
          />
        )}
      />
  
      <Spacer size="20px" />

      {/* Botão de Validação */}
      <button
        type="submit"
        className={`submit-button ${isValidated ? 'validated' : ''}`}
        disabled={loading || isValidated}
      >
        {loading ? 'Validando...' : isValidated ? 'Validado ✔' : 'Validar candidato'}
      </button>
    </form>
  );
}
